import clsx from "clsx";
import React, { FC, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { useAPI } from "../../hooks/useAPI";
import { CoupleType } from "../../types/PersonType";
import { CoupleModel } from "../../models/CoupleModel";
import { options } from "@fullcalendar/core/preact";

interface Props {
    onChange: any;
    name: string;
    value?: any;
    placeholder?: string;
    isSearchable?: boolean;
    isValid?: boolean;
    isTouched?: boolean;
    disabled?: boolean;
    couples?: CoupleType[];
}

const CoupleSelect: FC<Props> = (
    {
        onChange,
        value = undefined,
        placeholder = `Selecionar...`,
        isSearchable = false,
        isValid = false,
        isTouched = false,
        disabled = false,
        couples = []
    }) => {

    const promiseOptions = (inputValue: string) => {
        if (couples.length > 0) {
            return new Promise<Array<any>>((resolve) => {
                resolve(
                    couples
                        .filter((c) => CoupleModel().formatCoupleName(c).toLowerCase().includes(inputValue.toLowerCase()) || inputValue === "")
                        .map((value: CoupleType) => {
                            return { "label": `${CoupleModel().formatCoupleName(value)}`, "value": value.id };
                        })
                );
            });
        }

        return new Promise<Array<any>>((resolve) => {
            CoupleModel().list(undefined, { search: inputValue }, 1, 10).then((resp: any) => {
                let options: Array<any> = [];
                if (resp !== false) {
                    couples = resp.data;
                    resp.data.map((value: CoupleType) => {
                        options.push({ "label": `${CoupleModel().formatCoupleName(value)}`, "value": value.id });
                    });
                }
                resolve(options);
            });
        });
    };

    const getSelectedOption = (options: Array<any>, value: any) => {
        if (value === undefined || value === null) return undefined;
        for (let i in options) {
            if (options[i].value.toString() === value.toString()) {
                return options[i];
            }
        }
        return undefined;
    };

    const getDefaultOptions = () => {
        return couples.map((value: CoupleType) => { return { "label": `${CoupleModel().formatCoupleName(value)}`, "value": value.id }; });
    }

    const [defaultValue, setDefaultValue] = useState(
        getSelectedOption(getDefaultOptions(), value)
    );

    return (
        <AsyncSelect
            defaultOptions={getDefaultOptions()}
            placeholder={placeholder}
            onChange={(e: any) => {
                onChange(e, e ? (couples.find(c => c.id.toString() === e.value.toString()) || null) : null);
            }}
            loadOptions={promiseOptions}
            loadingMessage={(inputValue: any) => "Carregando..."}
            noOptionsMessage={(inputValue: any) => "Sem resultados"}
            isDisabled={disabled}
            defaultValue={defaultValue}
            className={clsx("react-select-container", {
                "is-invalid": isTouched && !isValid,
                "is-valid": isTouched && isValid
            })}
            classNamePrefix={'react-select'}
            isSearchable={isSearchable}
            isClearable={true}
        />
    );
};

export default CoupleSelect;